export default __webpack_public_path__ + "static/media/printNew.848e0c4c.svg";